import React, { useState, useRef } from "react";
import axiosInstance from "../../config/axiosConfig"; // Asegúrate de tener tu configuración de axios

const BuscarUsuario = ({ onSelect, onClear = () => {}}) => {
    const [usuarios, setUsuarios] = useState([]); // Lista de usuarios para el buscador
    const [textoBusqueda, setTextoBusqueda] = useState(""); // Texto del buscador
    const [loading, setLoading] = useState(false); // Estado para el indicador de carga
    const abortControllerRef = useRef(null);

    const buscarUsuarios = async () => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
        abortControllerRef.current = new AbortController();

        setLoading(true); // Activar el indicador de carga

        try {
            const response = await axiosInstance.get(`/usuario/busqueda/texto`, {
                params: {
                    search: textoBusqueda,
                },
                signal: abortControllerRef.current.signal,
            });
            if (response.data.error) {
                return;
            }
            setLoading(false);
            setUsuarios(response.data.data);
        } catch (error) {
            if (error.name !== "AbortError") {
                setLoading(false);
            }
        }
    };

    const handleSelectUsuario = (usuario) => {
        onSelect(usuario); // Llamamos a onSelect para pasar el usuario seleccionado
        setTextoBusqueda(`${usuario.nombre} ${usuario.apellido}`); // Actualizamos el input con el nombre del usuario
        setUsuarios([]); // Limpiamos la lista de usuarios
    };

    const handleClearSearch = () => {
        setTextoBusqueda(""); // Limpiamos el campo de búsqueda
        setUsuarios([]);
        onClear([]);
    };

    return (
        <div className="buscador-container mb-3">
            <label className="form-label">Buscar Enfermero/a</label>
            <div className="input-group">
                <input
                    type="text"
                    className="form-control buscador-input"
                    value={textoBusqueda}
                    onChange={(e) => setTextoBusqueda(e.target.value)}
                    onKeyUp={buscarUsuarios}
                    placeholder="Buscar por nombre o email"
                />
                {textoBusqueda && ( // Mostrar el botón solo si hay texto en el input
                    <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={handleClearSearch}
                    >
                        &times; {/* Icono de "x" */}
                    </button>
                )}
                {loading && (
                    <span className="input-group-text">
                        {/* Spinner de Bootstrap */}
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only"></span>
                        </div>
                    </span>
                )}
            </div>
            {usuarios.length > 0 && (
                <ul className="list-group search-results">
                    {usuarios.map((usuario) => (
                        <li
                            key={usuario.id}
                            className="list-group-item list-group-item-action"
                            onClick={() => handleSelectUsuario(usuario)} // Llamamos a onSelect cuando se hace clic en un usuario
                        >
                            {usuario.nombre} {usuario.apellido}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default BuscarUsuario;